<template>
  <div class="inline-filters" v-if="!isLoading">
    <div
      v-for="(filterOptions, filterKey, index) in availableFilters"
      :key="index"
    >
      <Permissioned section="bookings.filters">
        <InlineFilter
          v-if="size(filterOptions)"
          :label="getFilterTitle(filterKey)"
          :filters="filters[filterKey]"
          :options="filterOptions"
          @clear="handleClear(filterKey)"
        >
          <FilterCheckbox
            :options="getFilterOptions(filterOptions, filterKey)"
            :selectedValues="filters[filterKey]"
            @change="values => updateFilterFor(filterKey, values)"
          />
        </InlineFilter>
        <div v-if="index === size(availableFilters) - 1">
          <InlineFilter
            permission="date-created"
            v-for="({ name, fields }, index) in dateFilters"
            :key="name"
            :label="name"
            :filters="[filters[fields[0]], filters[fields[1]]]"
            @clear="clearDates(index)"
            isDate
            rangeDate
          >
            <DatePicker
              :inputValue="filters[fields[0]]"
              @updatedDate="value => updateFilterFor([fields[0]], value)"
              label="After"
            />
            <DatePicker
              :inputValue="filters[fields[1]]"
              @updatedDate="value => updateFilterFor([fields[1]], value)"
              label="Before"
            />
          </InlineFilter>
        </div>
      </Permissioned>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/common/DatePicker";
import InlineFilter from "@/components/common/InlineFilter";
import FilterCheckbox from "@/components/common/FilterCheckbox";
import Permissioned from "@/components/common/Permissioned";

import { omitBy, isEmpty, size, startCase, map } from "lodash";

export default {
  components: {
    InlineFilter,
    DatePicker,
    FilterCheckbox,
    Permissioned
  },
  props: {
    isLoading: Boolean,
    outerSelectedFilters: {
      type: Object,
      default: () => ({})
    },
    filterLabels: {
      type: Object,
      default: () => ({})
    },
    availableFilters: Object
  },
  data() {
    return {
      filters: Object.assign({}, this.outerSelectedFilters),
      dateFilters: [
        {
          name: "Start Date",
          fields: ["after_date", "before_date"]
        },
        {
          name: "Closing Date",
          fields: ["deadline_after_date", "deadline_before_date"]
        }
      ]
    };
  },
  methods: {
    clearFilters() {
      this.$emit("onClearFilters");
    },
    saveChanges() {
      const formattedFilters = omitBy(this.filters, isEmpty);
      this.$emit("filter", formattedFilters);
    },
    updateFilterFor(key, value) {
      this.filters = { ...this.filters, [key]: value };
      this.saveChanges();
    },
    getFilterTitle(filterName) {
      const label = this.filterLabels[filterName];
      if (label) {
        return label;
      }
      switch (filterName) {
        case "location_id":
          return "Location";
        case "cost_code":
          return "Cost Code";
        case "root_client_id":
          return "Root Organisation";
        case "manager_id":
          return "Hiring Manager";
        case "status":
          return "Status";
        case "client_id":
          return "Organisation";
        default:
          return filterName;
      }
    },
    getFilterOptions(options, filterName) {
      return filterName === "status"
        ? map(options, option => {
            return { text: startCase(option.text), value: option.value };
          })
        : options;
    },
    handleClear(key) {
      this.filters[key] = [];
      this.saveChanges();
    },
    clearDates(index) {
      this.filters[this.dateFilters[index].fields[0]] = null;
      this.filters[this.dateFilters[index].fields[1]] = null;
      this.saveChanges();
    },
    size
  },
  watch: {
    outerSelectedFilters(newValue) {
      if (isEmpty(newValue)) {
        this.filters = {};
      }
    }
  }
};
</script>

<style lang="scss"></style>
